/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserTokenRefreshCreateData, UserTokenRefreshCreateStatus200 } from "../types/UserTokenRefreshCreate.ts";

function getUserTokenRefreshCreateUrl() {
	const res = { method: "POST", url: `/api/user/token/refresh/` as const };

	return res;
}

/**
 * @description Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
 * {@link /api/user/token/refresh/}
 */
export async function userTokenRefreshCreate(
	data: UserTokenRefreshCreateData,
	config: Partial<RequestConfig<UserTokenRefreshCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<UserTokenRefreshCreateStatus200, ResponseErrorConfig<Error>, UserTokenRefreshCreateData>({
		method: "POST",
		url: getUserTokenRefreshCreateUrl().url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
